<template>
    <a-modal
        :visible="visible"
        :title="'Iframe Ayarları - ' + widget.title"
        width="600px"
        :footer="null"
        @cancel="$emit('close')"
        class="iframe-settings-modal"
        :destroyOnClose="true"
    >
        <a-form :form="form" layout="vertical">
            <!-- URL Ayarı -->
            <a-form-item label="URL">
                <a-input
                    v-model="previewSettings.url"
                    placeholder="https://example.com"
                    @change="validateUrl"
                />
                <div v-if="urlError" class="error-message">{{ urlError }}</div>
            </a-form-item>

            <!-- Yükseklik Ayarı -->
            <a-form-item label="Yükseklik (px)">
                <a-input-number
                    v-model="previewSettings.height"
                    :min="100"
                    :max="2000"
                    style="width: 100%"
                />
            </a-form-item>

            <!-- Yenileme Aralığı -->
            <a-form-item label="Otomatik Yenileme">
                <div class="refresh-interval-settings">
                    <a-switch v-model="autoRefreshEnabled" />
                    <a-input-number
                        v-if="autoRefreshEnabled"
                        v-model="previewSettings.refreshInterval"
                        :min="1"
                        :max="3600"
                        style="width: 120px"
                    />
                    <span v-if="autoRefreshEnabled">saniye</span>
                </div>
            </a-form-item>

            <!-- Önizleme -->
            <a-form-item label="Önizleme">
                <div class="preview-container" :style="{ height: '300px' }">
                    <iframe
                        v-if="isValidUrl"
                        :src="previewSettings.url"
                        frameborder="0"
                        style="width: 100%; height: 100%"
                    ></iframe>
                    <div v-else class="preview-placeholder">
                        <i class="material-icons">link_off</i>
                        <span>Geçerli bir URL giriniz</span>
                    </div>
                </div>
            </a-form-item>

            <!-- Kaydet/İptal Butonları -->
            <div class="form-actions">
                <a-button @click="$emit('close')">İptal</a-button>
                <a-button type="primary" @click="handleSave" :loading="saving" :disabled="!isValidUrl">
                    Kaydet
                </a-button>
            </div>
        </a-form>
    </a-modal>
</template>

<script>
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "IframeSettingsModal",
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        widget: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            previewSettings: _.cloneDeep(this.widget.settings || {
                url: "",
                height: 400,
                refreshInterval: 0,
            }),
            saving: false,
            urlError: null,
            autoRefreshEnabled: false,
        };
    },
    computed: {
        isValidUrl() {
            try {
                new URL(this.previewSettings.url);
                return true;
            } catch (e) {
                return false;
            }
        },
    },
    created() {
        this.autoRefreshEnabled = (this.previewSettings.refreshInterval || 0) > 0;
    },
    methods: {
        validateUrl() {
            try {
                new URL(this.previewSettings.url);
                this.urlError = null;
            } catch (e) {
                this.urlError = "Geçerli bir URL giriniz";
            }
        },
        async handleSave() {
            if (!this.isValidUrl) {
                this.$message.error("Lütfen geçerli bir URL giriniz");
                return;
            }

            try {
                this.saving = true;
                if (!this.autoRefreshEnabled) {
                    this.previewSettings.refreshInterval = 0;
                }
                await this.$emit("save", this.previewSettings);
            } catch (error) {
                console.error("Ayarlar kaydedilirken hata:", error);
                this.$message.error("Ayarlar kaydedilirken bir hata oluştu");
            } finally {
                this.saving = false;
            }
        },
    },
    watch: {
        autoRefreshEnabled(newValue) {
            if (!newValue) {
                this.previewSettings.refreshInterval = 0;
            } else if (this.previewSettings.refreshInterval === 0) {
                this.previewSettings.refreshInterval = 60; // Varsayılan 60 saniye
            }
        },
    },
});
</script>

<style lang="scss">
.iframe-settings-modal {
    .refresh-interval-settings {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .preview-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: hidden;

        .preview-placeholder {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #fafafa;
            color: rgba(0, 0, 0, 0.45);
            gap: 8px;

            .material-icons {
                font-size: 48px;
            }
        }
    }

    .error-message {
        color: #ff4d4f;
        font-size: 12px;
        margin-top: 4px;
    }

    .form-actions {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}
</style> 